import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { CONFIG } from 'utils/config';

const loadAwsRum = () => {
    if (!CONFIG.VITE_AWS_RUM_ENABLED || !CONFIG.VITE_AWS_RUM_APPLICATION_ID) {
        return;
    }

    try {
        const config: AwsRumConfig = {
            sessionSampleRate: CONFIG.VITE_AWS_RUM_RATE,
            guestRoleArn: CONFIG.VITE_AWS_RUM_GUEST_ROLE_ARN,
            identityPoolId: CONFIG.VITE_AWS_RUM_POOL_ID,
            endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
            telemetries: ['performance'],
            allowCookies: false,
            enableXRay: false,
        };

        new AwsRum(
            CONFIG.VITE_AWS_RUM_APPLICATION_ID,
            '1.0.0',
            'us-east-1',
            config,
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
};

export default loadAwsRum;
